// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import theme from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import ErrorBoundary from "./components/ErrorBoundary";
import SidebarView from "./components/SidebarView";
import "./assets/styling.css";
import { useContext } from "react";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";
import RegionBar from "./components/RegionBar";

const AppTheme = {
  backgroundColor: "#0f0f0f",
  position: "fixed",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  color: "white",
  scrollbarColor: "rgba(255, 255, 255, 0.5) rgba(22, 22, 22, 0.8)",
  overflow: "auto",
  fontFamily: "sans-serif",
};

// Create a new component to handle the conditional rendering
const AppContent = () => {
  const { userInfo } = useContext(AuthContext);

  return (
    <div style={AppTheme}>
      <ErrorBoundary>
        <div style={{ display: userInfo ? "flex" : "block" }}>
          {userInfo && <SidebarView />}
          <App />
        </div>
        <ToastContainer />
      </ErrorBoundary>
    </div>
  );
};

axios.defaults.withCredentials = true;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  </ThemeProvider>
);
